var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", { attrs: { id: "the-top" } }),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "button",
        class: { visible: _vm.visible },
        attrs: { id: "back-to-top", href: "#the-top" }
      },
      [_vm._v("↑")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }